// extracted by mini-css-extract-plugin
export default {"searchInput":"SearchInput_searchInput__WhD5t","searchIcon":"SearchInput_searchIcon__6sjBI","search":"SearchInput_search__VdYgM","iconBorder":"SearchInput_iconBorder__-H2Ju"};